const LEAVES = ['title', 'paragraph', 'img', 'button'];
const PARENTS = ['row', 'container'];

/**
 * Returns the first element renderFromStructure cannot draw, or null when the whole structure is valid.
 *
 * @param {Array} elements - Array. (Mandatory) The structure, or the elements of a row or container.
 * @param {Array} path - Array. (Optional) 1-based position of `elements` inside the structure.
 *
 * @returns {Object|null} { type, path }: the element's type and its 1-based position.
 */
export default function findUnknownElement(elements, path = []) {
  if (!Array.isArray(elements)) return { type: String(elements), path };

  for (let index = 0; index < elements.length; index += 1) {
    const el = elements[index];
    const position = [...path, index + 1];
    let unknown = null;

    if (Array.isArray(el)) unknown = findUnknownElement(el, position);
    else if (PARENTS.includes(el?.type))
      unknown = Array.isArray(el.elements)
        ? findUnknownElement(el.elements, position)
        : { type: el.type, path: position };
    else if (!LEAVES.includes(el?.type))
      unknown = { type: String(el?.type), path: position };

    if (unknown) return unknown;
  }
  return null;
}
